// New translations for registration and email confirmation
const newTranslations = {
    // Registration and auth
    'registracija_sekme': 'Reģistrācija veiksmīga!',
    'vardas': 'Vārds',
    'pavarde': 'Uzvārds',
    'ivestiVarda': 'Ievadiet vārdu',
    'ivestiPavarde': 'Ievadiet uzvārdu',
    'slaptazodzio_keitimas': 'Paroles maiņa',
    'current_password': 'Pašreizējā parole',
    'neteisingas_dabartinis_slaptazodis': 'Nepareiza pašreizējā parole',
    'profilis_atnaujintas': 'Profils veiksmīgi atjaunināts!',
    'keisti_slaptazodi': 'Mainīt',
    'slaptazodzio_keitimo_aprasymas': 'Nosūtīsim paroles maiņas saiti',
    'slaptazodzio_keitimo_nuoroda_issiusta': 'Paroles maiņas saite ir nosūtīta',
    'registracijos_klaida': 'Lietotājs ar šo e-pastu jau ir reģistrēts vai nav apstiprināts',
    'sistemos_klaida': 'Radās sistēmas kļūda. Lūdzu, mēģiniet vēlāk.',
    'registruojama': 'Reģistrējas...',
    'privalomi_laukai': 'Lūdzu, aizpildiet visus obligātos laukus',
    'prisijungimo_klaida': 'Pieteikšanās neizdevās. Jūsu konts nav apstiprināts administratora vai pārbaudiet savu e-pastu un paroli.',
    'jungiamasi': 'Savienojas...',
    'user_exists': 'Lietotājs ar šo e-pastu jau ir reģistrēts vai nav apstiprināts',
    'esu_organizacijos_atstovas': 'Esmu pilnvarots organizācijas pārstāvis un varu izveidot kontu organizācijas vārdā',
    
    // Email confirmation
    'email_patvirtinimas': 'E-pasta apstiprinājums',
    'tikrinamas_email': 'Pārbauda jūsu e-pasta apstiprinājumu...',
    'email_patvirtintas': 'Jūsu e-pasts ir veiksmīgi apstiprināts!',
    'email_patvirtintas_sekmes': 'E-pasts veiksmīgi apstiprināts! Tagad administrators apstiprinās jūsu kontu.',
    'email_patvirtintas_admin': 'Administratoram jāapstiprina jūsu konts, pirms varat izmantot sistēmu. Tas var aizņemt līdz 24 stundām.',
    'patvirtinimo_klaida': 'Radās kļūda, apstiprinot e-pastu.',
    'truksta_parametru': 'Trūkst nepieciešamo apstiprinājuma parametru.',
    'netinkamas_patvirtinimo_tipas': 'Nederīgs apstiprinājuma tips. Lūdzu, mēģiniet vēlreiz.',
    'grizti_i_prisijungima': 'Atgriezties uz pieteikšanās lapu',
    
    // Admin confirmation
    'laukiama_admin_patvirtinimo': 'Jūsu konts gaida administratora apstiprinājumu',
    'jūsų_paskyra_laukia_administratoriaus_patvirtinimo': 'Jūsu e-pasts ir veiksmīgi apstiprināts, bet pirms sistēmas izmantošanas jūsu kontu jāapstiprina administratoram.',
    'gauti_patvirtinimą_gali_užtrukti_iki_24_val': 'Apstiprināšanas process var aizņemt līdz 24 stundām. Jūs saņemsiet e-pasta paziņojumu, kad jūsu konts būs apstiprināts.',
    'account_not_confirmed_by_admin': 'Administrators vēl nav apstiprinājis jūsu kontu. Jūs varēsiet izmantot sistēmu, kad administrators apstiprinās jūsu kontu.',
    
    // Admin guide
    'vartotojų_patvirtinimas': 'Lietotāja apstiprinājums',
    'nauji_vartotojai_turi_būti_patvirtinti_prieš_naudojimą': 'Jauniem lietotājiem jābūt apstiprinātiem pirms sistēmas lietošanas.',
    'patvirtinti_vartotojai_gali_prisijungti_ir_naudotis_sistema': 'Apstiprinātie lietotāji var pieteikties un izmantot sistēmu.',
    'nepatvirtinti_vartotojai_negali_prisijungti': 'Neapstiprinātie lietotāji nevar pilnībā izmantot sistēmu.',
    'vartotojai_kurių_el_paštas_nepatvirtintas_gali_neturėti_prieigos': 'Lietotājiem, kuru e-pasts nav apstiprināts, var nebūt piekļuves sistēmai.',
    
    // Registration success
    'registration_success_email_confirmation': 'Reģistrācija veiksmīga! Pārbaudiet savu e-pastu, lai apstiprinātu kontu.',
    
    // Company confirmation
    'patvirtinti_imone': 'Apstiprināt uzņēmumu',
    'Vartotojas sėkmingai patvirtintas': 'Uzņēmums veiksmīgi apstiprināts!',
    'Klaida patvirtinant vartotoją': 'Kļūda, apstiprinot uzņēmumu. Lūdzu, mēģiniet vēlreiz.',

    // Subscription
    'galioja_iki': 'Derīgs līdz',
    'galiojanti': 'Derīgs',
    'negaliojanti': 'Nederīgs',
    'prenumeratos_info': 'Izvēlieties abonēšanas veidu un saglabājiet izmaiņas',
    'Įmonė sėkmingai patvirtinta!': 'Uzņēmums veiksmīgi apstiprināts!',
    'Metai pridėti. Nepamirškite paspausti "Išsaugoti" mygtuką, kad pakeitimai būtų išsaugoti.': 'Gadi pievienoti. Neaizmirstiet noklikšķināt uz pogas "Saglabāt", lai saglabātu izmaiņas.',
    'login_error': 'Parole ir nepareiza vai konts nav apstiprināts',
    'db_migration_info': 'Ja vēl neesat mainījis savu paroli, lūdzu, noklikšķiniet uz "Aizmirsu paroli" un mēs jums nosūtīsim saiti paroles maiņai. Datubāze tika migrēta uz citiem serveriem, tāpēc jums jāizveido jauna parole.',

    // Forgot password
    'forgotPass.invalidEmail': 'Nederīgs e-pasta formāts',
    'forgotPass.resetLinkSent': 'Paroles atjaunošanas saite ir nosūtīta',
    'forgotPass.resetError': 'Kļūda, sūtot atjaunošanas saiti',

    // OTP verification
    'send_code': 'Sūtīt kodu',
    'verify_code': 'Apstiprināt kodu',
    'resend_code': 'Sūtīt kodu vēlreiz',
    'resend_code_in': 'Kodu varēs nosūtīt vēlreiz pēc',
    'otp_sent': 'Apstiprinājuma kods ir nosūtīts!',
    'otp_resent': 'Jauns kods ir nosūtīts!',
    'invalid_otp': 'Nederīgs kods. Mēģiniet vēlreiz.',
    'verification_code': 'Apstiprinājuma kods',
    'otp_verification_desc': 'Ievadiet saņemto 6 ciparu kodu',
    'enter_6_digit_code': 'Ievadiet 6 ciparu kodu'
};

export default newTranslations;
